/**
 * Shared OTP constants used across lodge-a-complaint (OTP modal) and otp-verification flow.
 */
export const OTP_LENGTH = 6

export const OTP_ERROR_INCOMPLETE = 'Please enter the complete OTP'

export const TIMER_INTERVAL_MS = 1000
export const PROGRESS_COMPLETE = 100

/** Default seconds until “Resend OTP” when the API omits `can_resend_after_seconds` */
export const DEFAULT_OTP_RESEND_AFTER_SECONDS = 60
